import React, { useRef, useState } from "react";
import { Helmet } from "react-helmet-async";
import { Link, useNavigate } from "react-router-dom";
import { ErrorMessage, Field, FieldArray, Form, Formik } from "formik";
import InputWithLabel from "../../../../Components/InputWithLabel";
import { ErrorToast, SuccessToast } from "../../../../Utils/SweetAlert";
import {
  Validation,
  DiscoverInitialValue,
  GuideIntialValues,
  AddGuideValidationSchema,
} from "../../constant";
import "react-phone-input-2/lib/style.css";
import {
  useMutateCreateDiscover,
  useMutateCreateGuide,
  useMutateCreateImage,
} from "../../hooks/useApiHook";
import selectIcon from "../../../../assets/Images/selecticon.png";
import IconUpload from "../../../../Components/SingleProfileSelect";
import CustomSelect from "../../../../Utils/CustomSelect";
import TextArea from "../../../../Components/TextArea";
import AdminProfileSelect from "../../../../Components/AdminProfileSelect";
import DiscoverImageSelect from "../../../Discover/components/ImageUpload";
import { AiOutlineCloudUpload } from "react-icons/ai";
import BackButton from "../../../../Components/BackButton";
import SaveButton from "../../../../Components/SaveButton";

const AddGuide = () => {
  const navigate = useNavigate();

  /**
   * Ref variables
   */
  const imagesInputRef = useRef([]);
  const howToImgInputRef = useRef([]);
  const howToRemoveImgInputRef = useRef([]);
  const howToCleanImgInputRef = useRef([]);
  const howToChangeImgInputRef = useRef([]);
  const imageContainerRef = useRef([]);
  const dropAreaRef = useRef([]);

  const nameRef = useRef(null);
  const descriptionRef = useRef(null);

  const scrollTop = () => {
    window.scrollTo(0, 0);
  };

  const triggerFileInput = (index) => {
    imageInputRef.current[index].click();
  };



  /**
   * Api
   */
  const addGuideApi = useMutateCreateGuide();
  const addImageApi = useMutateCreateImage();
  const imageInputRef = useRef([]);
  const [isLoading, setIsLoading] = useState(false);
  const [uploadingProductIndex, setUploadingProductIndex] = useState(null);



  /**
   * Used for spliting file name
   * @param {string} url "Url of selected file"
   * @returns "Returns splited image name"
   */
  function getLastNameFromUrl(url) {
    const parts = url.split("/");
    return parts[parts.length - 1];
  }

  /**
   * Used to handle submit
   * @param {any} values "Values of form fields"
   */

  const handleSubmit = (values, { setSubmitting, setErrors }) => {
    AddGuideValidationSchema.validate(values, { abortEarly: false }).then(
      () => {
        const reqData = {
          name: values?.name,
          image: values?.image ? getLastNameFromUrl(values?.image) : "",
          productDetails: values?.productDetails?.map((item) => {
            return {
              description: item?.description,
              images: item?.images?.map((img) => {
                if (typeof img === "string") {
                  return getLastNameFromUrl(img);
                } else {
                  return img?.name;
                }
              }),
              howToUse: item?.howToUse?.map((use) => {
                return {
                  description: use?.description,
                  images: [getLastNameFromUrl(use?.images)],
                };
              }),
              howToRemove: item?.howToRemove?.map((use) => {
                return {
                  description: use?.description,
                };
              }),
              howToClean: item?.howToClean?.map((use) => {
                return {
                  description: use?.description,
                };
              }),
              howToChange: item?.howToChange?.map((use) => {
                return {
                  description: use?.description,
                };
              }),
            };
          }),
        };

        setIsLoading(true);
        addGuideApi.mutate(reqData, {
          onSuccess: (response) => {
            SuccessToast(response?.message || "Added successful.");
            navigate("/admin/guide-listing");
            setIsLoading(false);
          },
          onError: (error) => {
            ErrorToast(error?.response?.data?.message || "Server error.");
            setIsLoading(false);
          },
        });

        setSubmitting(false);
      }
    );
  };

  return (
    <>
      <Helmet>
        <title>OVE | Admin Add Guide product</title>
      </Helmet>
      <div className="page-wrapper">
        <div className="content container-fluid">
          <div className="row">
            <div className="col-md-12">
              <div className="card card-border overflow-visible">
                <div className="card-body">
                  <div className="page-header d-block">
                    <div className="row">
                      <div className="col">
                        <h3 className="page-title">Add Guide Product</h3>
                      </div>
                      <div className="col-auto d-flex align-items-center justify-content-center">
                        <BackButton to="/admin/guide-listing" />
                      </div>
                    </div>
                  </div>

                  <Formik
                    initialValues={GuideIntialValues}
                    validationSchema={AddGuideValidationSchema}
                    validateOnChange
                    onSubmit={handleSubmit}
                  >
                    {(formik) => {
                      const { setFieldValue, values, isSubmitting } = formik;
                      return (
                        <Form>
                          <div className="row">
                            <div className="col-3">
                              <label>
                                Upload Icon
                                <span className="text-danger">*</span>
                              </label>
                              <IconUpload
                                values={values}
                                setFieldValue={setFieldValue}
                                addImageApi={addImageApi}
                                selectIcon={selectIcon}
                                type="image"
                              />
                            </div>

                            <div className="col-9">
                              <Field
                                Label="Name"
                                type="text"
                                name="name"
                                placeholder="Enter Name"
                                component={InputWithLabel}
                              />
                            </div>
                          </div>

                          <div className="row">
                            <div>
                              <div className="row d-flex justify-content-between my-2">
                                <div className="col">
                                  <h4 className="mt-5">Product Details</h4>
                                </div>
                              </div>

                              {values?.productDetails?.map(
                                (guide, guideIndex) => (
                                  <div key={guideIndex}>
                                    <section className="setting-pro-border">
                                      <FieldArray name="productDetails">
                                        {({ push, remove }) => (
                                          <div className="row">
                                            <div className="col-md-6">
                                              <label>
                                                Image
                                                <span className="text-danger">
                                                  *
                                                </span>
                                              </label>
                                              <div
                                                // ref={dropAreaRef}
                                                onDrop={(event) => {
                                                  event.preventDefault();
                                                  dropAreaRef?.current[
                                                    guideIndex
                                                  ]?.classList?.remove(
                                                    "drag-over"
                                                  );
                                                  const files =
                                                    event.dataTransfer.files;

                                                  const formData =
                                                    new FormData();
                                                  for (
                                                    let i = 0;
                                                    i < files.length;
                                                    i++
                                                  ) {
                                                    formData.append(
                                                      "images",
                                                      files[i]
                                                    );
                                                  }

                                                  addImageApi.mutate(formData, {
                                                    onSuccess: async (
                                                      response
                                                    ) => {
                                                      const imgAry = [];
                                                      await values?.productDetails[
                                                        guideIndex
                                                      ]?.images?.map((img) => {
                                                        imgAry?.push(img);
                                                      });
                                                      await response?.data?.map(
                                                        (item) => {
                                                          imgAry.push(item);
                                                        }
                                                      );
                                                      await setFieldValue(
                                                        `productDetails[${guideIndex}].images`,
                                                        imgAry
                                                      );
                                                    },
                                                    onError: (error) => {
                                                      ErrorToast(
                                                        error?.response?.data
                                                          ?.message ||
                                                        "Server Error."
                                                      );
                                                    },
                                                  });
                                                }}
                                                onDragOver={(event) => {
                                                  event.preventDefault();
                                                  dropAreaRef?.current[
                                                    guideIndex
                                                  ]?.classList?.add(
                                                    "drag-over"
                                                  );
                                                }}
                                                onDragLeave={() => {
                                                  dropAreaRef?.current[
                                                    guideIndex
                                                  ]?.classList?.remove(
                                                    "drag-over"
                                                  );
                                                }}
                                                className="drop-area dotted-border"
                                                onClick={() =>
                                                  triggerFileInput(guideIndex)
                                                }
                                              >
                                                <div className="upload-icon">
                                                  {uploadingProductIndex === guideIndex ? (
                                                    <div className="spinner-border spinner-border-sm loader-theme" role="status">
                                                      <span className="visually-hidden">Loading...</span>
                                                    </div>
                                                  ) : (
                                                    <AiOutlineCloudUpload
                                                      size={24}
                                                    />
                                                  )}
                                                </div>
                                                <p>
                                                  <span className="drop-area-text">
                                                    {" "}
                                                    {uploadingProductIndex === guideIndex ? "Uploading..." : "Click to upload"}
                                                  </span>{" "}
                                                  {uploadingProductIndex !== guideIndex && "or drag and drop"}
                                                </p>
                                                <input
                                                  type="file"
                                                  multiple
                                                  ref={(element) =>
                                                  (imageInputRef.current[
                                                    guideIndex
                                                  ] = element)
                                                  }
                                                  name={`productDetails[${guideIndex}].images`}
                                                  accept="image/png, image/jpeg, image/jpg"
                                                  onChange={(event) => {
                                                    const files =
                                                      event.target.files;
                                                    const formData =
                                                      new FormData();
                                                    for (
                                                      let i = 0;
                                                      i < files.length;
                                                      i++
                                                    ) {
                                                      formData.append(
                                                        "images",
                                                        files[i]
                                                      );
                                                    }
                                                    setUploadingProductIndex(guideIndex);
                                                    addImageApi.mutate(
                                                      formData,
                                                      {
                                                        onSuccess: async (
                                                          response
                                                        ) => {
                                                          const imgAry = [];
                                                          await values?.productDetails[
                                                            guideIndex
                                                          ]?.images?.map(
                                                            (img) => {
                                                              imgAry?.push(img);
                                                            }
                                                          );
                                                          await response?.data?.map(
                                                            (item) => {
                                                              imgAry.push(item);
                                                            }
                                                          );
                                                          await setFieldValue(
                                                            `productDetails[${guideIndex}].images`,
                                                            imgAry
                                                          );
                                                          setUploadingProductIndex(null);
                                                        },
                                                        onError: (error) => {
                                                          ErrorToast(
                                                            error?.response
                                                              ?.data?.message ||
                                                            "Server error."
                                                          );
                                                          setUploadingProductIndex(null);
                                                        },
                                                      }
                                                    );
                                                  }}
                                                  className="file-input"
                                                />
                                              </div>

                                              <ErrorMessage
                                                name={`productDetails[${guideIndex}].images`}
                                                component="div"
                                                className="text-danger"
                                              />
                                            </div>

                                            <div className="col-md-6">
                                              {" "}
                                              <Field
                                                Label="Description"
                                                type="text"
                                                name={`productDetails[${guideIndex}].description`}
                                                placeholder="Enter Description"
                                                component={TextArea}
                                                className="guide-description"
                                                style={{ height: "90px" }}
                                                handleChange={(e) => {
                                                  setFieldValue(
                                                    `productDetails[${guideIndex}].description`,
                                                    e.value
                                                  );
                                                }}
                                              />
                                            </div>
                                            <div
                                              ref={(element) =>
                                              (imageContainerRef.current[
                                                guideIndex
                                              ] = element)
                                              }
                                              className="col-12"
                                            >
                                              {values?.productDetails[
                                                guideIndex
                                              ]?.images?.length > 0 &&
                                                values?.productDetails[
                                                  guideIndex
                                                ]?.images.map((url, index) => {
                                                  return (
                                                    <div
                                                      key={index}
                                                      className="image-wrapper"
                                                    >
                                                      <img
                                                        src={url}
                                                        className="preview-image"
                                                        alt={`uploaded ${url}`}
                                                      />
                                                      <button
                                                        className="remove-button"
                                                        type="button"
                                                        onClick={async () => {
                                                          const updatedImages =
                                                            values?.productDetails[
                                                              guideIndex
                                                            ]?.images?.filter(
                                                              (item) =>
                                                                item !== url
                                                            );
                                                          setFieldValue(
                                                            `productDetails[${guideIndex}].images`,
                                                            updatedImages
                                                          );
                                                        }}
                                                      >
                                                        X
                                                      </button>
                                                    </div>
                                                  );
                                                })}
                                            </div>
                                          </div>
                                        )}
                                      </FieldArray>
                                    </section>
                                    <div>
                                      <FieldArray
                                        name={`productDetails[${guideIndex}].howToUse`}
                                      >
                                        {({
                                          push: pushMember,
                                          remove: removeMember,
                                        }) => (
                                          <div
                                            className={
                                              guide?.howToUse?.length == 0
                                                ? ""
                                                : "section-border-use"
                                            }
                                          >
                                            <section
                                              className={
                                                guide?.howToUse?.length == 0
                                                  ? "border-section-use-btn"
                                                  : ""
                                              }
                                            >
                                              <div className="col-12 d-flex justify-content-between align-items-center pl-0">
                                                <h4 className="mb-0">
                                                  How To Use?
                                                </h4>
                                                {guide?.howToUse?.length ==
                                                  0 && (
                                                    <button
                                                      className="add-use-button plus-add-button"
                                                      type="button"
                                                      onClick={() =>
                                                        pushMember({
                                                          description: "",
                                                          images: "",
                                                        })
                                                      }
                                                    >
                                                      <svg
                                                        stroke="currentColor"
                                                        fill="#FFF"
                                                        stroke-width="0"
                                                        viewBox="0 0 448 512"
                                                        height="14px"
                                                        width="20px"
                                                        xmlns="http://www.w3.org/2000/svg"
                                                      >
                                                        <path d="M256 80c0-17.7-14.3-32-32-32s-32 14.3-32 32V224H48c-17.7 0-32 14.3-32 32s14.3 32 32 32H192V432c0 17.7 14.3 32 32 32s32-14.3 32-32V288H400c17.7 0 32-14.3 32-32s-14.3-32-32-32H256V80z"></path>
                                                      </svg>
                                                      Add
                                                    </button>
                                                  )}
                                              </div>
                                            </section>
                                            {guide?.howToUse?.map(
                                              (member, memberIndex) => (
                                                <div key={memberIndex}>
                                                  <div className="row">
                                                    <div className="col-md-4">
                                                      <Field
                                                        Label="Image"
                                                        name={`productDetails[${guideIndex}].howToUse[${memberIndex}].images`}
                                                        component={
                                                          DiscoverImageSelect
                                                        }
                                                        useArrayForImageUrl={false}
                                                        require={true}
                                                      />
                                                    </div>
                                                    <div className="col-md-8">
                                                      <Field
                                                        Label="Description"
                                                        name={`productDetails[${guideIndex}].howToUse[${memberIndex}].description`}
                                                        placeholder="Enter Description"
                                                        component={TextArea}
                                                      />
                                                    </div>
                                                  </div>

                                                  <div className="row">
                                                    <div className="col-12 text-end d-flex justify-content-end">
                                                      <button
                                                        className="add-use-button me-2 plus-add-button"
                                                        type="button"
                                                        onClick={() =>
                                                          pushMember({
                                                            description: "",
                                                            images: "",
                                                          })
                                                        }
                                                      >
                                                        <svg
                                                          stroke="currentColor"
                                                          fill="#FFF"
                                                          strokeWidth="0"
                                                          viewBox="0 0 448 512"
                                                          height="14px"
                                                          width="20px"
                                                          xmlns="http://www.w3.org/2000/svg"
                                                        >
                                                          <path d="M256 80c0-17.7-14.3-32-32-32s-32 14.3-32 32V224H48c-17.7 0-32 14.3-32 32s14.3 32 32 32H192V432c0 17.7 14.3 32 32 32s32-14.3 32-32V288H400c17.7 0 32-14.3 32-32s-14.3-32-32-32H256V80z"></path>
                                                        </svg>
                                                        Add
                                                      </button>
                                                      <button
                                                        className="remove-use-button"
                                                        type="button"
                                                        onClick={() =>
                                                          removeMember(
                                                            memberIndex
                                                          )
                                                        }
                                                      /*
                                                      disabled={
                                                        guide?.howToRemove
                                                          ?.length == 0 &&
                                                        guide?.howToClean
                                                          ?.length == 0 &&
                                                        guide?.howToChange
                                                          ?.length == 0
                                                      }
                                                     */
                                                      >
                                                        Remove
                                                      </button>
                                                    </div>
                                                  </div>
                                                </div>
                                              )
                                            )}
                                          </div>
                                        )}
                                      </FieldArray>
                                    </div>

                                    <div>
                                      <FieldArray
                                        name={`productDetails[${guideIndex}].howToRemove`}
                                      >
                                        {({
                                          push: pushMember,
                                          remove: removeMember,
                                        }) => (
                                          <div
                                            className={
                                              guide?.howToRemove?.length === 0
                                                ? ""
                                                : "section-border-use"
                                            }
                                          >
                                            <section
                                              className={
                                                guide?.howToRemove?.length === 0
                                                  ? "border-section-use-btn"
                                                  : ""
                                              }
                                            >
                                              <div className="col-12 d-flex justify-content-between align-items-center pl-0">
                                                <h4 className="mb-0">
                                                  How To Remove?
                                                </h4>

                                                {guide?.howToRemove?.length >
                                                  0 && (
                                                    <svg
                                                      stroke="none"
                                                      fill="#AD5ADC"
                                                      strokeWidth="32"
                                                      viewBox="0 0 24 24"
                                                      height="35px"
                                                      width="35px"
                                                      xmlns="http://www.w3.org/2000/svg"
                                                      onClick={() => {
                                                        for (
                                                          let i =
                                                            guide?.howToRemove
                                                              ?.length - 1;
                                                          i >= 0;
                                                          i--
                                                        ) {
                                                          removeMember(i);
                                                        }
                                                      }}
                                                      className="remove-all-button"
                                                    >
                                                      <g id="Circle_Remove">
                                                        <g>
                                                          <path d="M9.525,13.765a.5.5,0,0,0,.71.71c.59-.59,1.175-1.18,1.765-1.76l1.765,1.76a.5.5,0,0,0,.71-.71c-.59-.58-1.18-1.175-1.76-1.765.41-.42.82-.825,1.23-1.235.18-.18.35-.36.53-.53a.5.5,0,0,0-.71-.71L12,11.293,10.235,9.525a.5.5,0,0,0-.71.71L11.293,12Z"></path>
                                                          <path d="M12,21.933A9.933,9.933,0,1,1,21.934,12,9.945,9.945,0,0,1,12,21.933ZM12,3.067A8.933,8.933,0,1,0,20.934,12,8.944,8.944,0,0,0,12,3.067Z"></path>
                                                        </g>
                                                      </g>
                                                    </svg>
                                                  )}
                                                {guide?.howToRemove?.length ===
                                                  0 && (
                                                    <button
                                                      className="add-use-button plus-add-button"
                                                      type="button"
                                                      onClick={() =>
                                                        pushMember({
                                                          description: "",
                                                        })
                                                      }
                                                    >
                                                      <svg
                                                        stroke="currentColor"
                                                        fill="#FFF"
                                                        strokeWidth="0"
                                                        viewBox="0 0 448 512"
                                                        height="14px"
                                                        width="20px"
                                                        xmlns="http://www.w3.org/2000/svg"
                                                      >
                                                        <path d="M256 80c0-17.7-14.3-32-32-32s-32 14.3-32 32V224H48c-17.7 0-32 14.3-32 32s14.3 32 32 32H192V432c0 17.7 14.3 32 32 32s32-14.3 32-32V288H400c17.7 0 32-14.3 32-32s-14.3-32-32-32H256V80z"></path>
                                                      </svg>
                                                      Add
                                                    </button>
                                                  )}
                                              </div>
                                            </section>

                                            {guide?.howToRemove?.map(
                                              (member, memberIndex) => (
                                                <div
                                                  key={memberIndex}
                                                  className="description-row"
                                                >
                                                  <div className="row mt-3">
                                                    <div className="col-md-10">
                                                      <Field
                                                        Label={
                                                          guideIndex === 0 &&
                                                          memberIndex === 0 &&
                                                          "Description"
                                                        }
                                                        require={
                                                          guideIndex === 0 &&
                                                          memberIndex === 0 && (
                                                            <span className="text-danger">
                                                              *
                                                            </span>
                                                          )
                                                        }
                                                        type="text"
                                                        name={`productDetails[${guideIndex}].howToRemove[${memberIndex}].description`}
                                                        placeholder="Enter Description"
                                                        component={TextArea}
                                                        className="guide-howtouse-description"
                                                        style={{
                                                          height: "70px",
                                                        }}
                                                        handleChange={(e) => {
                                                          setFieldValue(
                                                            `productDetails[${guideIndex}].howToRemove[${memberIndex}].description`,
                                                            e.target.value
                                                          );
                                                        }}
                                                      />
                                                      <svg
                                                        stroke="currentColor"
                                                        fill="currentColor"
                                                        strokeWidth="0"
                                                        viewBox="0 0 24 24"
                                                        height="18px"
                                                        width="18px"
                                                        xmlns="http://www.w3.org/2000/svg"
                                                        className={
                                                          guideIndex === 0 &&
                                                            memberIndex === 0 &&
                                                            "Description"
                                                            ? "remove-des-icon"
                                                            : "remove-description-icon"
                                                        }
                                                        onClick={() =>
                                                          removeMember(
                                                            memberIndex
                                                          )
                                                        }
                                                      >
                                                        <g id="Circle_Remove">
                                                          <g>
                                                            <path d="M9.525,13.765a.5.5,0,0,0,.71.71c.59-.59,1.175-1.18,1.765-1.76l1.765,1.76a.5.5,0,0,0,.71-.71c-.59-.58-1.18-1.175-1.76-1.765.41-.42.82-.825,1.23-1.235.18-.18.35-.36.53-.53a.5.5,0,0,0-.71-.71L12,11.293,10.235,9.525a.5.5,0,0,0-.71.71L11.293,12Z"></path>
                                                            <path d="M12,21.933A9.933,9.933,0,1,1,21.934,12,9.945,9.945,0,0,1,12,21.933ZM12,3.067A8.933,8.933,0,1,0,20.934,12,8.944,8.944,0,0,0,12,3.067Z"></path>
                                                          </g>
                                                        </g>
                                                      </svg>
                                                    </div>
                                                    <div className="col-2">
                                                      {memberIndex ===
                                                        guide?.howToRemove
                                                          ?.length -
                                                        1 && (
                                                          <div className="row mt-3">
                                                            <div className="col-md-10">
                                                              <button
                                                                className={
                                                                  guideIndex ===
                                                                    0 &&
                                                                    memberIndex ===
                                                                    0 &&
                                                                    "Description"
                                                                    ? "add-use-button add-des-button plus-add-button"
                                                                    : "add-use-button add-rmdes-button plus-add-button"
                                                                }
                                                                type="button"
                                                                onClick={() =>
                                                                  pushMember({
                                                                    description:
                                                                      "",
                                                                  })
                                                                }
                                                              >
                                                                <svg
                                                                  stroke="currentColor"
                                                                  fill="#FFF"
                                                                  strokeWidth="0"
                                                                  viewBox="0 0 448 512"
                                                                  height="14px"
                                                                  width="20px"
                                                                  xmlns="http://www.w3.org/2000/svg"
                                                                >
                                                                  <path d="M256 80c0-17.7-14.3-32-32-32s-32 14.3-32 32V224H48c-17.7 0-32 14.3-32 32s14.3 32 32 32H192V432c0 17.7 14.3 32 32 32s32-14.3 32-32V288H400c17.7 0 32-14.3 32-32s-14.3-32-32-32H256V80z"></path>
                                                                </svg>
                                                                Add
                                                              </button>
                                                            </div>
                                                          </div>
                                                        )}
                                                    </div>
                                                  </div>
                                                </div>
                                              )
                                            )}
                                          </div>
                                        )}
                                      </FieldArray>
                                    </div>

                                    <div>
                                      <FieldArray
                                        name={`productDetails[${guideIndex}].howToClean`}
                                      >
                                        {({
                                          push: pushMember,
                                          remove: removeMember,
                                        }) => (
                                          <div
                                            className={
                                              guide?.howToClean?.length === 0
                                                ? ""
                                                : "section-border-use"
                                            }
                                          >
                                            <section
                                              className={
                                                guide?.howToClean?.length === 0
                                                  ? "border-section-use-btn"
                                                  : ""
                                              }
                                            >
                                              <div className="col-12 d-flex justify-content-between align-items-center pl-0">
                                                <h4 className="mb-0">
                                                  How To Clean?
                                                </h4>

                                                {guide?.howToClean?.length >
                                                  0 && (
                                                    <svg
                                                      stroke="none"
                                                      fill="#AD5ADC"
                                                      strokeWidth="32"
                                                      viewBox="0 0 24 24"
                                                      height="35px"
                                                      width="35px"
                                                      xmlns="http://www.w3.org/2000/svg"
                                                      onClick={() => {
                                                        for (
                                                          let i =
                                                            guide?.howToClean
                                                              ?.length - 1;
                                                          i >= 0;
                                                          i--
                                                        ) {
                                                          removeMember(i);
                                                        }
                                                      }}
                                                      className="remove-all-button"
                                                    >
                                                      <g id="Circle_Remove">
                                                        <g>
                                                          <path d="M9.525,13.765a.5.5,0,0,0,.71.71c.59-.59,1.175-1.18,1.765-1.76l1.765,1.76a.5.5,0,0,0,.71-.71c-.59-.58-1.18-1.175-1.76-1.765.41-.42.82-.825,1.23-1.235.18-.18.35-.36.53-.53a.5.5,0,0,0-.71-.71L12,11.293,10.235,9.525a.5.5,0,0,0-.71.71L11.293,12Z"></path>
                                                          <path d="M12,21.933A9.933,9.933,0,1,1,21.934,12,9.945,9.945,0,0,1,12,21.933ZM12,3.067A8.933,8.933,0,1,0,20.934,12,8.944,8.944,0,0,0,12,3.067Z"></path>
                                                        </g>
                                                      </g>
                                                    </svg>
                                                  )}
                                                {guide?.howToClean?.length ===
                                                  0 && (
                                                    <button
                                                      className="add-use-button plus-add-button"
                                                      type="button"
                                                      onClick={() =>
                                                        pushMember({
                                                          description: "",
                                                        })
                                                      }
                                                    >
                                                      <svg
                                                        stroke="currentColor"
                                                        fill="#FFF"
                                                        strokeWidth="0"
                                                        viewBox="0 0 448 512"
                                                        height="14px"
                                                        width="20px"
                                                        xmlns="http://www.w3.org/2000/svg"
                                                      >
                                                        <path d="M256 80c0-17.7-14.3-32-32-32s-32 14.3-32 32V224H48c-17.7 0-32 14.3-32 32s14.3 32 32 32H192V432c0 17.7 14.3 32 32 32s32-14.3 32-32V288H400c17.7 0 32-14.3 32-32s-14.3-32-32-32H256V80z"></path>
                                                      </svg>
                                                      Add
                                                    </button>
                                                  )}
                                              </div>
                                            </section>

                                            {guide?.howToClean?.map(
                                              (member, memberIndex) => (
                                                <div
                                                  key={memberIndex}
                                                  className="description-row"
                                                >
                                                  <div className="row mt-3">
                                                    <div className="col-md-10">
                                                      <Field
                                                        Label={
                                                          guideIndex === 0 &&
                                                          memberIndex === 0 &&
                                                          "Description"
                                                        }
                                                        require={
                                                          guideIndex === 0 &&
                                                          memberIndex === 0 && (
                                                            <span className="text-danger">
                                                              *
                                                            </span>
                                                          )
                                                        }
                                                        type="text"
                                                        name={`productDetails[${guideIndex}].howToClean[${memberIndex}].description`}
                                                        placeholder="Enter Description"
                                                        component={TextArea}
                                                        className="guide-howtouse-description"
                                                        style={{
                                                          height: "70px",
                                                        }}
                                                        handleChange={(e) => {
                                                          setFieldValue(
                                                            `productDetails[${guideIndex}].howToClean[${memberIndex}].description`,
                                                            e.target.value
                                                          );
                                                        }}
                                                      />
                                                      <svg
                                                        stroke="currentColor"
                                                        fill="currentColor"
                                                        strokeWidth="0"
                                                        viewBox="0 0 24 24"
                                                        height="18px"
                                                        width="18px"
                                                        xmlns="http://www.w3.org/2000/svg"
                                                        className={
                                                          guideIndex === 0 &&
                                                            memberIndex === 0 &&
                                                            "Description"
                                                            ? "remove-des-icon"
                                                            : "remove-description-icon"
                                                        }
                                                        onClick={() =>
                                                          removeMember(
                                                            memberIndex
                                                          )
                                                        }
                                                      >
                                                        <g id="Circle_Remove">
                                                          <g>
                                                            <path d="M9.525,13.765a.5.5,0,0,0,.71.71c.59-.59,1.175-1.18,1.765-1.76l1.765,1.76a.5.5,0,0,0,.71-.71c-.59-.58-1.18-1.175-1.76-1.765.41-.42.82-.825,1.23-1.235.18-.18.35-.36.53-.53a.5.5,0,0,0-.71-.71L12,11.293,10.235,9.525a.5.5,0,0,0-.71.71L11.293,12Z"></path>
                                                            <path d="M12,21.933A9.933,9.933,0,1,1,21.934,12,9.945,9.945,0,0,1,12,21.933ZM12,3.067A8.933,8.933,0,1,0,20.934,12,8.944,8.944,0,0,0,12,3.067Z"></path>
                                                          </g>
                                                        </g>
                                                      </svg>
                                                    </div>
                                                    <div className="col-2">
                                                      {memberIndex ===
                                                        guide?.howToClean
                                                          ?.length -
                                                        1 && (
                                                          <div className="row mt-3">
                                                            <div className="col-md-10">
                                                              <button
                                                                className={
                                                                  guideIndex ===
                                                                    0 &&
                                                                    memberIndex ===
                                                                    0 &&
                                                                    "Description"
                                                                    ? "add-use-button add-des-button plus-add-button"
                                                                    : "add-use-button add-rmdes-button plus-add-button"
                                                                }
                                                                type="button"
                                                                onClick={() =>
                                                                  pushMember({
                                                                    description:
                                                                      "",
                                                                  })
                                                                }
                                                              >
                                                                <svg
                                                                  stroke="currentColor"
                                                                  fill="#FFF"
                                                                  strokeWidth="0"
                                                                  viewBox="0 0 448 512"
                                                                  height="14px"
                                                                  width="20px"
                                                                  xmlns="http://www.w3.org/2000/svg"
                                                                >
                                                                  <path d="M256 80c0-17.7-14.3-32-32-32s-32 14.3-32 32V224H48c-17.7 0-32 14.3-32 32s14.3 32 32 32H192V432c0 17.7 14.3 32 32 32s32-14.3 32-32V288H400c17.7 0 32-14.3 32-32s-14.3-32-32-32H256V80z"></path>
                                                                </svg>
                                                                Add
                                                              </button>
                                                            </div>
                                                          </div>
                                                        )}
                                                    </div>
                                                  </div>
                                                </div>
                                              )
                                            )}
                                          </div>
                                        )}
                                      </FieldArray>
                                    </div>

                                    <div>
                                      <FieldArray
                                        name={`productDetails[${guideIndex}].howToChange`}
                                      >
                                        {({
                                          push: pushMember,
                                          remove: removeMember,
                                        }) => (
                                          <div
                                            className={
                                              guide?.howToChange?.length === 0
                                                ? ""
                                                : "section-border-use"
                                            }
                                          >
                                            <section
                                              className={
                                                guide?.howToChange?.length === 0
                                                  ? "border-section-use-btn"
                                                  : ""
                                              }
                                            >
                                              <div className="col-12 d-flex justify-content-between align-items-center pl-0">
                                                <h4 className="mb-0">
                                                  How To Change?
                                                </h4>

                                                {guide?.howToChange?.length >
                                                  0 && (
                                                    <svg
                                                      stroke="none"
                                                      fill="#AD5ADC"
                                                      strokeWidth="32"
                                                      viewBox="0 0 24 24"
                                                      height="35px"
                                                      width="35px"
                                                      xmlns="http://www.w3.org/2000/svg"
                                                      onClick={() => {
                                                        for (
                                                          let i =
                                                            guide?.howToChange
                                                              ?.length - 1;
                                                          i >= 0;
                                                          i--
                                                        ) {
                                                          removeMember(i);
                                                        }
                                                      }}
                                                      className="remove-all-button"
                                                    >
                                                      <g id="Circle_Remove">
                                                        <g>
                                                          <path d="M9.525,13.765a.5.5,0,0,0,.71.71c.59-.59,1.175-1.18,1.765-1.76l1.765,1.76a.5.5,0,0,0,.71-.71c-.59-.58-1.18-1.175-1.76-1.765.41-.42.82-.825,1.23-1.235.18-.18.35-.36.53-.53a.5.5,0,0,0-.71-.71L12,11.293,10.235,9.525a.5.5,0,0,0-.71.71L11.293,12Z"></path>
                                                          <path d="M12,21.933A9.933,9.933,0,1,1,21.934,12,9.945,9.945,0,0,1,12,21.933ZM12,3.067A8.933,8.933,0,1,0,20.934,12,8.944,8.944,0,0,0,12,3.067Z"></path>
                                                        </g>
                                                      </g>
                                                    </svg>
                                                  )}
                                                {guide?.howToChange?.length ===
                                                  0 && (
                                                    <button
                                                      className="add-use-button plus-add-button"
                                                      type="button"
                                                      onClick={() =>
                                                        pushMember({
                                                          description: "",
                                                        })
                                                      }
                                                    >
                                                      <svg
                                                        stroke="currentColor"
                                                        fill="#FFF"
                                                        strokeWidth="0"
                                                        viewBox="0 0 448 512"
                                                        height="14px"
                                                        width="20px"
                                                        xmlns="http://www.w3.org/2000/svg"
                                                      >
                                                        <path d="M256 80c0-17.7-14.3-32-32-32s-32 14.3-32 32V224H48c-17.7 0-32 14.3-32 32s14.3 32 32 32H192V432c0 17.7 14.3 32 32 32s32-14.3 32-32V288H400c17.7 0 32-14.3 32-32s-14.3-32-32-32H256V80z"></path>
                                                      </svg>
                                                      Add
                                                    </button>
                                                  )}
                                              </div>
                                            </section>

                                            {guide?.howToChange?.map(
                                              (member, memberIndex) => (
                                                <div
                                                  key={memberIndex}
                                                  className="description-row"
                                                >
                                                  <div className="row mt-3">
                                                    <div className="col-md-10">
                                                      <Field
                                                        Label={
                                                          guideIndex === 0 &&
                                                          memberIndex === 0 &&
                                                          "Description"
                                                        }
                                                        require={
                                                          guideIndex === 0 &&
                                                          memberIndex === 0 && (
                                                            <span className="text-danger">
                                                              *
                                                            </span>
                                                          )
                                                        }
                                                        type="text"
                                                        name={`productDetails[${guideIndex}].howToChange[${memberIndex}].description`}
                                                        placeholder="Enter Description"
                                                        component={TextArea}
                                                        className="guide-howtouse-description"
                                                        style={{
                                                          height: "70px",
                                                        }}
                                                        handleChange={(e) => {
                                                          setFieldValue(
                                                            `productDetails[${guideIndex}].howToChange[${memberIndex}].description`,
                                                            e.target.value
                                                          );
                                                        }}
                                                      />
                                                      <svg
                                                        stroke="currentColor"
                                                        fill="currentColor"
                                                        strokeWidth="0"
                                                        viewBox="0 0 24 24"
                                                        height="18px"
                                                        width="18px"
                                                        xmlns="http://www.w3.org/2000/svg"
                                                        className={
                                                          guideIndex === 0 &&
                                                            memberIndex === 0 &&
                                                            "Description"
                                                            ? "remove-des-icon"
                                                            : "remove-description-icon"
                                                        }
                                                        onClick={() =>
                                                          removeMember(
                                                            memberIndex
                                                          )
                                                        }
                                                      >
                                                        <g id="Circle_Remove">
                                                          <g>
                                                            <path d="M9.525,13.765a.5.5,0,0,0,.71.71c.59-.59,1.175-1.18,1.765-1.76l1.765,1.76a.5.5,0,0,0,.71-.71c-.59-.58-1.18-1.175-1.76-1.765.41-.42.82-.825,1.23-1.235.18-.18.35-.36.53-.53a.5.5,0,0,0-.71-.71L12,11.293,10.235,9.525a.5.5,0,0,0-.71.71L11.293,12Z"></path>
                                                            <path d="M12,21.933A9.933,9.933,0,1,1,21.934,12,9.945,9.945,0,0,1,12,21.933ZM12,3.067A8.933,8.933,0,1,0,20.934,12,8.944,8.944,0,0,0,12,3.067Z"></path>
                                                          </g>
                                                        </g>
                                                      </svg>
                                                    </div>
                                                    <div className="col-2">
                                                      {memberIndex ===
                                                        guide?.howToChange
                                                          ?.length -
                                                        1 && (
                                                          <div className="row mt-3">
                                                            <div className="col-md-10">
                                                              <button
                                                                className={
                                                                  guideIndex ===
                                                                    0 &&
                                                                    memberIndex ===
                                                                    0 &&
                                                                    "Description"
                                                                    ? "add-use-button add-des-button plus-add-button"
                                                                    : "add-use-button add-rmdes-button plus-add-button"
                                                                }
                                                                type="button"
                                                                onClick={() =>
                                                                  pushMember({
                                                                    description:
                                                                      "",
                                                                  })
                                                                }
                                                              >
                                                                <svg
                                                                  stroke="currentColor"
                                                                  fill="#FFF"
                                                                  strokeWidth="0"
                                                                  viewBox="0 0 448 512"
                                                                  height="14px"
                                                                  width="20px"
                                                                  xmlns="http://www.w3.org/2000/svg"
                                                                >
                                                                  <path d="M256 80c0-17.7-14.3-32-32-32s-32 14.3-32 32V224H48c-17.7 0-32 14.3-32 32s14.3 32 32 32H192V432c0 17.7 14.3 32 32 32s32-14.3 32-32V288H400c17.7 0 32-14.3 32-32s-14.3-32-32-32H256V80z"></path>
                                                                </svg>
                                                                Add
                                                              </button>
                                                            </div>
                                                          </div>
                                                        )}
                                                    </div>
                                                  </div>
                                                </div>
                                              )
                                            )}
                                          </div>
                                        )}
                                      </FieldArray>
                                    </div>
                                    {guideIndex === 0 ?
                                      <p className="warning fs-5">
                                        Note: Please provide any one detail.
                                      </p> : ""}
                                  </div>
                                )
                              )}
                            </div>
                            <div>

                            </div>
                          </div>

                          <SaveButton loading={isLoading} />
                        </Form>
                      );
                    }}
                  </Formik>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default AddGuide;
